import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import simple from "../../assets/images/resume/sample-resume.png";
import creative from "../../assets/images/resume/responsive-resume-template.gif";
import modern  from "../../assets/images/resume/draco.png";
import { Row, Col, Card, CardImg, CardBody, CardTitle, Button, Container } from "reactstrap";

const themes = [
  { id: 1, name: "Simple", image: simple, url: "/simple-theme" },
  { id: 2, name: "Modern", image: modern, url: "/modern-theme" },
  { id: 3, name: "Creative", image: creative, url: "/creative-theme" },
];

export default function ResumeThemes(props) {
  const [selectedTheme, setSelectedTheme] = useState(null);
  const [isConfirming, setIsConfirming] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleThemeSelect = (theme) => {
    setSelectedTheme(theme);
    setIsConfirming(true); // Show the confirmation prompt
  };

  const handleConfirm = () => {
    if (selectedTheme) {
      props.history.push(selectedTheme.url); // Navigate to selected theme's URL
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs
          title="Dashboard"
          breadcrumbItem="Select Theme For Your Resume"
        />

        <Container fluid>
          <Row className="justify-content-center">
            {themes.map((theme) => (
              <Col key={theme.id} xs={12} sm={6} md={4} lg={4} className="mb-3">
                <Card
                  onClick={() => handleThemeSelect(theme)}
                  style={{
                    cursor: "pointer",
                    border: selectedTheme?.id === theme.id ? "2px solid #1976d2" : "none",
                    transition: "border 0.3s",
                  }}
                >
                  <CardImg top src={theme.image} alt={theme.name} />
                  <CardBody className="text-center">
                    <CardTitle tag="h5">{theme.name}</CardTitle>
                  </CardBody>
                </Card>
                {/* Show confirmation message below each theme in mobile view */}
                {isConfirming && selectedTheme?.id === theme.id && isMobileView && (
                  <Box mt={2} className="text-center">
                    <p className="mb-2">Are you sure you want to use the "{selectedTheme.name}" theme?</p>
                    <Button color="primary" onClick={handleConfirm} className="mr-2">Yes, Use This Theme</Button>
                    <Button color="danger" onClick={() => setIsConfirming(false)}>Cancel</Button>
                  </Box>
                )}
              </Col>
            ))}
          </Row>

          {/* Show confirmation message centered in larger views */}
          {isConfirming && selectedTheme && !isMobileView && (
            <Row className="justify-content-center">
              <Col xs={10} sm={8} md={6} lg={4} className="text-center mt-3">
                <Box>
                  <p className="mb-3">Are you sure you want to use the "{selectedTheme.name}" theme?</p>
                  <Button color="primary" onClick={handleConfirm} className="mr-2">Yes, Use This Theme</Button>
                  <Button color="danger" onClick={() => setIsConfirming(false)}>Cancel</Button>
                </Box>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
}
